<template>
  <div id="app">
    <headerNav :class="{scollBack: scrolled,color_white:scrolled}" />
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <returnTop />
    <router-view />
    <footerNav />
  </div>
</template>
<script>
  import headerNav from './components/header.vue'
  import footerNav from './components/foot.vue'
  import returnTop from './components/returnTop.vue';
  import router from '@/router'; // 确保路径正确
  export default {
    components: {
      headerNav,
      footerNav,
      returnTop
    },
    data() {
      return {
        scrolled: false, // 用于记录页面是否滚动
        backColor: false,
      };
    },
    mounted() {  // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      // 组件销毁时移除滚动事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
      // 使用全局前置守卫
      router.beforeEach((to, from, next) => {
        this.toTop(); // 每次路由切换时调用toTop方法
        next();
      });
    },
    methods: {
      toTop() {
        window.scrollTo({
          top: 0, // 滚动到页面顶部
          behavior: 'smooth' // 平滑滚动
        });
      },

      handleScroll() {
        // 如果页面滚动距离大于 0，则设置 scrolled 为 true
        this.scrolled = window.scrollY > 0;
        if (window.scrollY == 0) {
          this.backColor = true;
        } else {
          this.backColor = false;
        }
      },
    },
  };
</script>
<style lang="scss">
  #app {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    /* color: #2c3e50; */
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    background-color: white;
  }

  body {
    margin: 0px;
    overflow-x: hidden;
    /* 隐藏水平滚动条 */
    overflow-y: scroll;
    /* 显示垂直滚动条 */
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .scollBack {

    background-color: #ffffff;
  }

  .color_white a {
    color: #333333 !important;
  }

  img {
    width: 100%;
    height: 100%
  }

  ::-webkit-scrollbar {
    width: 8px;
    /* 对于垂直滚动条，设置宽度 */
  }

  ::-webkit-scrollbar-thumb {
    background: #333333;
    /* 滑块颜色 */
    /* border-radius: 50px; */
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background: #d9d9da;
    /* 轨道颜色 */
  }

  /* 滑块hover效果 */
  ::-webkit-scrollbar-thumb:hover {
    background: #333333;
    /* 滑块hover颜色 */
  }

  .root {
    width: 100%;
  }

  .mouseCursor {
    cursor: pointer;
  }

  .backAnima {
    position: relative;
    width: 6vw;
    height: auto;
  }

  .backAnima>div {
    position: relative;
    z-index: 3;
    /* 确保文字在背景上方 */
    width: 7vw;
    padding: 1vw 0vw;
    font-size: 1.6vw;
    /* 可调整字体大小 */
    color: #00A2E9;
    font-weight: bold;
  }

  /* 设置背景图并实现动画 */
  .backAnima::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(./assets/img5.png);
    background-size: cover;
    background-position: center;
    margin-bottom: 15px;
    rotate: 5deg;
    z-index: 0;
    /* 确保背景图在文字下方 */
    /* animation: backgroundAnimation 6s ease infinite; */
  }

  /* scale---缩放，rotate---旋转 skew---倾斜 translate---平移 */
  /* 定义背景动画 */
  @keyframes backgroundAnimation {
    0% {
      transform: rotate(5deg);
    }

    25% {
      transform: rotate(-30deg)scaleY(0.5)translateY(15px);
    }

    50% {
      transform: scaleX(-1)rotate(0deg) translateY(15px) scale(0.8)rotate(-45deg);
    }

    75% {
      transform: scale(1)rotate(-10deg)translateY(25px);
    }

    100% {
      transform: rotate(5deg);
    }
  }

  /* 针对手机端 */
  @media screen and (max-width: 1023px) {
    .backAnima>div {
      width: 10vw;
      font-size: 2.4vw;
    }

    .backAnima {
      width: 10vw;
    }
  }
</style>